import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column p-ai-center" }
const _hoisted_2 = {
  key: 0,
  src: "/assets/icons/challenges/student/not-available-challenge.svg",
  alt: "not available",
  class: "challenge-icon"
}
const _hoisted_3 = {
  key: 1,
  src: "/assets/icons/challenges/student/expired-challenge.svg",
  alt: "expired",
  class: "challenge-icon"
}
const _hoisted_4 = {
  key: 2,
  src: "/assets/icons/challenges/student/error-uploading-challenge.svg",
  alt: "error",
  class: "challenge-icon"
}
const _hoisted_5 = {
  key: 3,
  src: "/assets/icons/challenges/student/upload-challenge.svg",
  alt: "upload",
  class: "challenge-icon"
}
const _hoisted_6 = { class: "p-text-center p-mt-3 p2" }
const _hoisted_7 = {
  key: 5,
  class: "p-text-center p-mt-1 p2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    bgDark: "",
    border: "",
    class: "p-p-5"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isDisabled || _ctx.isEmpty)
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : (_ctx.isExpired)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (_ctx.hasError || _ctx.isComponentError)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : (_openBlock(), _createElementBlock("img", _hoisted_5)),
        (!_ctx.hasError && !_ctx.isDisabled && !_ctx.isComponentError && !_ctx.isEmpty)
          ? (_openBlock(), _createElementBlock("span", {
              key: 4,
              class: _normalizeClass(["p1 medium p-mt-3", _ctx.tagColor])
            }, _toDisplayString(_ctx.isExpired ? _ctx.copies.expired.tag : _ctx.hasError ? _ctx.copies.error.tag : _ctx.copies.toReceive.tag), 3))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.customCopies && _ctx.customCopies.line1 !== undefined
            ? _ctx.customCopies.line1
            : _ctx.isExpired
            ? _ctx.copies.expired.text
            : _ctx.hasError
            ? _ctx.copies.error.text
            : _ctx.isDisabled
            ? _ctx.copies.disabled.text
            : _ctx.isComponentError
            ? _ctx.copies.componentError.text
            : _ctx.isEmpty
            ? _ctx.copies.empty.text
            : _ctx.copies.toReceive.text) + " " + _toDisplayString(!_ctx.isExpired ? _ctx.dateString : ''), 1),
        (_ctx.hasError || _ctx.isComponentError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.customCopies && _ctx.customCopies.line2 !== undefined
            ? _ctx.customCopies.error
            : _ctx.hasError
            ? _ctx.copies.error.suggestion
            : _ctx.copies.componentError.suggestion), 1))
          : _createCommentVNode("", true),
        _hoisted_8
      ])
    ]),
    _: 1
  }))
}